import Button from "@/components/Button"
import Container from "@/components/Container"
import DefaultLayout from "@/layouts/DefaultLayout"
import { ArrowLeftIcon } from "@heroicons/react/20/solid"
import { ReactNode } from "react"

const ErrorPage = ({ status }: { status: number }) => {
  const title =
    {
      503: "Service unavailable",
      500: "Server error",
      404: "Page not found",
      403: "Forbidden",
    }[status] || "Unexpected error"

  const description = {
    503: "Sorry, we are doing some maintenance. Please check back soon.",
    500: "Whoops, something went wrong on our servers.",
    404: "Sorry, the page you are looking for could not be found.",
    403: "Sorry, you are forbidden from accessing this page.",
  }[status]

  return (
    <section>
      <Container className="my-16 flex flex-col items-center justify-center sm:my-20">
        <p className="text-chessdrop-500 text-center text-base font-semibold">
          {status} error
        </p>
        <h1 className="mt-3 text-center text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
          {title}
        </h1>
        <p className="mt-4 text-center text-pretty text-gray-600 sm:mt-6 sm:text-lg">
          {description}
        </p>
        <Button href="/" className="mt-6" size="lg" style="secondary">
          <ArrowLeftIcon className="size-4" />
          Go home
        </Button>
      </Container>
    </section>
  )
}

export default ErrorPage

ErrorPage.layout = (page: ReactNode) => <DefaultLayout>{page}</DefaultLayout>
